import * as React from 'react';

import { Box, Chip, SxProps, Theme } from '@mui/material';
import * as clients from '../../core/api/clients';

interface IIncidentStatus {
  status: clients.IncidentStatus | undefined;
  sxBox?: SxProps<Theme> | undefined
  sxChip?: SxProps<Theme> | undefined
}

function IncidentStatusChip({ status, sxBox, sxChip }: IIncidentStatus) {
  const getStatusColor = (statusText: clients.IncidentStatus | undefined) => {
    switch (statusText) {
      case clients.IncidentStatus.Open: return 'success';
      case clients.IncidentStatus.Closed: return 'primary';
      default: return undefined;
    }
  };

  return (
    <Box sx={sxBox}>
      <Chip sx={sxChip} variant="filled" label={status} color={getStatusColor(status)} />
    </Box>
  );
}

export default IncidentStatusChip;
